import Mustache from "mustache";
export default class {
  // THIS IS NOT A STIMULUS CONTOLLER!
  constructor() {
    this.wrapper = document.body.querySelector("[data-class='deliverySelect']");
    if (this.wrapper) {
      this.start();
    }
  }

  start() {
    this.countries = this.fetchDataObject("countries");
    this.postages = this.fetchDataObject("postages");
    this.topCountryIso = this.wrapper.dataset.topCountryIso;
    this.locale = this.wrapper.dataset.locale;

    if (this.countries && this.postages) {
      this.initializeCustomSelect(this.countries, this.topCountryIso);
      this.initializeCountriesList(this.countries);
    }
  }

  selectOnChange(event) {
    const val = event.target.value;
    this.setCountryPostageInfo(val);
  }

  setCountryPostageInfo(countryId) {
    this.wrapper
      .querySelectorAll('[data-name="placed-deliveryInfo"]')
      .forEach((e) => e.remove());
    const country = this.countries.find(({ id }) => id === parseInt(countryId));
    const infoTpl = this.findTemplate("deliveryInfo-el");

    const listTpl = this.findTemplate("deliveryInfo");
    const list = this.htmlToElement(listTpl);

    country.postage_ids.map((id, index) => {
      const convertedTpl = this.postageMapperparams(
        infoTpl,
        country,
        id,
        index
      );
      const node_element = this.htmlToElement(convertedTpl);
      list.querySelector("table").append(node_element);
    }, this);
    this.wrapper
      .querySelector(".delivery-link.link")
      .insertAdjacentHTML("afterend", list.outerHTML);
  }

  initializeCustomSelect(countries, topCountryIso) {
    const selectEl = this.createSelectElement();
    this.assignOptionsToSelect(selectEl, countries, topCountryIso);
    selectEl.selectedIndex = 0;

    selectEl.addEventListener("change", (e) => this.selectOnChange(e));

    const selectWrapperEl = this.createSelectWrapper(selectEl);
    this.wrapper.insertAdjacentElement("afterbegin", selectWrapperEl);

    this.setCountryPostageInfo(selectEl.options[0].value);
  }

  createSelectElement() {
    const el = document.createElement("select");
    el.id = "delivery_select";
    el.classList = ["jrpass-select"];
    return el;
  }

  createSelectWrapper(selectEl) {
    const el = document.createElement("div");
    el.classList = ["field--default field--select"];
    el.appendChild(selectEl);
    return el;
  }

  assignOptionsToSelect(select, countriesData, topCountryIso) {
    const option_c = document.createElement("option");
    const sortedCountriesData = countriesData.sort(function (x, y) {
      return x.iso == topCountryIso ? -1 : x.iso == topCountryIso ? 1 : 0;
    });
    const options = sortedCountriesData.map((c) => {
      const option = option_c.cloneNode(true);
      option.text = c.name;
      option.value = c.id;
      select.appendChild(option);
    });
  }

  initializeCountriesList(countries) {
    const listTpl = this.findTemplate("deliveryTable");
    const list = this.htmlToElement(listTpl);

    countries.map((country) => {
      const elementTpl = this.findTemplate("deliveryTable-el");

      country.postage_ids.map((id, index) => {
        const convertedTpl = this.postageMapperparams(
          elementTpl,
          country,
          id,
          index
        );

        const node_element = this.htmlToElement(convertedTpl);
        list.querySelector("table").append(node_element);
      });
    }, this);
    this.wrapper.insertAdjacentHTML("beforeend", list.outerHTML);
  }

  postageMapperparams(baseTpl, country, postageId, _postageIndex) {
    const country_postage = this.postages[`${postageId}`];
    console.log(country);
    console.log(country_postage);
    let newTpl = baseTpl.replaceAll("%{count}", "{{POSTAGE_LEAD_TIME}}"); // hacky way to reuse rails count translation
    const params = {
      lead_time_is_next_day:
        this.locale == "en" && country_postage.lead_time == 1,
      // (true = 1/false = other) helper for days counter translation
      lead_days_equal_one: country_postage.lead_time > 1 ? false : true,
      // POSTAGE_COUNTRY_NAME: postageIndex == 0 ? country.name : "", // in case we wanna have only one country name in first element
      POSTAGE_COUNTRY_NAME: country.name,
      POSTAGE_NAME: country_postage.name,
      POSTAGE_LEAD_TIME: country_postage.lead_time,
      POSTAGE_PRICE: country_postage.price,
      ROYAL_MAIL_UK: country.iso == "GB" && country_postage.brand == "Royal Mail",
      FEDEX_UK: country.iso == "GB" && country_postage.brand == "FedEx",
      iso_is_gb: country.iso == "GB",
    };
    return Mustache.render(newTpl, params);
  }

  htmlToElement(html) {
    const el = document.createElement("template");
    el.innerHTML = html;
    return el.content.firstChild;
  }

  findTemplate(name) {
    try {
      return this.wrapper.querySelector(`template[data-template="${name}"]`)
        .innerHTML;
    } catch {
      return undefined;
    }
  }

  fetchDataObject(name) {
    try {
      const data = JSON.parse(this.wrapper.dataset[`${name}`]);
      return Object.keys(data).length === 0 ? null : data;
    } catch {
      return null;
    }
  }
}
